import CallOutlinedIcon from '@mui/icons-material/CallOutlined'
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import MailOutlinedIcon from '@mui/icons-material/MailOutlined'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import { useContext, useState } from 'react'
import avatarImage from 'src/assets/images/avatars/2.jpg'
import { BusinessPaywallContext } from '../paywall/PaywallProvider'
import {
  NoSuccessManagerButton,
  NoSuccessManagerHeading,
  NoSuccessManagerSubext,
  SuccessManagerAvatar,
  YourSuccessManagerText,
} from './SuccessManagerFloaterStyles'
import styled from 'styled-components'

const SidebarSection = styled.div`
  flex-shrink: 0;
  padding: 16px 20px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
`

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  background: transparent;
  border: none;
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
  }

  .chevron {
    margin-left: auto;
    transition: transform 0.2s;
  }

  &.expanded .chevron {
    transform: rotate(180deg);
  }
`

const ExpandedContent = styled.div`
  margin-top: 12px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
`

const SidebarAvatar = styled(SuccessManagerAvatar)`
  width: 48px;
  height: 48px;
  margin-bottom: 8px;
`

const ContactRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
`

const EscalateLink = styled.a`
  display: block;
  margin-top: 12px;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.85);

  &:hover {
    text-decoration: underline;
    color: #fff;
  }
`

const SidebarDetailsBox = styled.div`
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
`

const SidebarProfileName = styled.span`
  color: rgba(255, 255, 255, 0.95);
  font-size: 15px;
  font-weight: 700;
`

export function SuccessManagerSidebarItem({ data, themeType }) {
  const { togglePaywall } = useContext(BusinessPaywallContext)
  const [expanded, setExpanded] = useState(false)

  return (
    <SidebarSection>
      <ToggleButton
        type="button"
        className={expanded ? 'expanded' : ''}
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
        aria-label={expanded ? 'Collapse Success Manager' : 'Expand Success Manager'}
      >
        <SupportAgentIcon sx={{ fontSize: 22 }} />
        <span>Success Manager</span>
        <ExpandMoreIcon className="chevron" sx={{ fontSize: 20 }} />
      </ToggleButton>

      {expanded && (
        <ExpandedContent>
          {!data ? (
            <>
              <SidebarAvatar src={avatarImage} alt="Success Manager" />
              <YourSuccessManagerText>Your Success Manager</YourSuccessManagerText>
              <SidebarDetailsBox>
                <SidebarProfileName>Aditya Verma</SidebarProfileName>
                <ContactRow>
                  <a href="tel:+918105819700" style={{ color: 'inherit' }} aria-label="Call">
                    <CallOutlinedIcon sx={{ fontSize: 20 }} />
                  </a>
                  <a href="mailto:aditya.v@aumhum.com" style={{ color: 'inherit' }} aria-label="Email">
                    <MailOutlinedIcon sx={{ fontSize: 20 }} />
                  </a>
                  <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: 20 }} aria-label="Chat" />
                </ContactRow>
              </SidebarDetailsBox>
              <EscalateLink href="mailto:namaste@aumhum.com">Escalate →</EscalateLink>
            </>
          ) : (
            <>
              <NoSuccessManagerHeading>Want To Reach Higher Ranks?</NoSuccessManagerHeading>
              <NoSuccessManagerButton onClick={togglePaywall}>
                <NoSuccessManagerSubext>Get</NoSuccessManagerSubext>
                <strong>Success Manager</strong>
              </NoSuccessManagerButton>
            </>
          )}
        </ExpandedContent>
      )}
    </SidebarSection>
  )
}
